export enum Languages {
  Spanish = 'es',
  English = 'en',
  Catalan = 'ca',
}
